import { getCheckedValue, OptionSwitch } from '@Pages/RetroSynthesis/ProjectParametersDialog/ProjectParametersHelpers';

export const RX2_AUTOPLAN_MAX_BEST_PATHS = 'RX2_AUTOPLAN_MAX_BEST_PATHS';
export const RX2_AUTOPLAN_MAX_ALTERNATIVE_BRANCHES = 'RX2_AUTOPLAN_MAX_ALTERNATIVE_BRANCHES';
export const RX2_AUTOPLAN_MAX_DEPTH = 'RX2_AUTOPLAN_MAX_DEPTH';

const RX2_AUTOPLAN_STOP_WHEN_COMMERCIALLY_AVAILABLE = 'RX2_AUTOPLAN_STOP_WHEN_COMMERCIALLY_AVAILABLE';
const RX2_AUTOPLAN_DEFAULT_YIELD = 'RX2_AUTOPLAN_DEFAULT_YIELD';
const RX2_AUTOPLAN_FULL_ROUTES = 'RX2_AUTOPLAN_FULL_ROUTES';

export const extractDefaultPublishedParameters = (resp) => ({
  numberOfPlans: getCheckedValue(RX2_AUTOPLAN_MAX_BEST_PATHS, resp),
  maxBranch: getCheckedValue(RX2_AUTOPLAN_MAX_ALTERNATIVE_BRANCHES, resp),
  maxDepth: getCheckedValue(RX2_AUTOPLAN_MAX_DEPTH, resp),
  stopCommand: getCheckedValue(RX2_AUTOPLAN_STOP_WHEN_COMMERCIALLY_AVAILABLE, resp) === OptionSwitch.ON,
  defaultYield: parseInt(getCheckedValue(RX2_AUTOPLAN_DEFAULT_YIELD, resp), 10),
  fullSynthesisPlan: getCheckedValue(RX2_AUTOPLAN_FULL_ROUTES, resp) === OptionSwitch.ON,
});
